import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { Route, Redirect } from "react-router-dom";
import { signOut, clearAuthCookies, clearSessionId } from "../features/user/actions";

import FullScreenLoading from "../features/shared/components/misc/FullScreenLoading";
import SessionExpired from "../features/shared/components/notices/SessionExpired";
import { isRestrictedAccess } from '../utils/cookies';

import Cookies from 'universal-cookie';
const cookies = new Cookies();

class PrivateRoute extends Component {

  constructor(props) {
    super(props)
    this.state = {
      isRestrictedAccess: false
    }
  }

  componentDidMount() {
    if (isRestrictedAccess()) {
      this.setState({ isRestrictedAccess: true })
    }
  }

  signOut = () => {
    this.props.signOut();
    this.props.redirectToLogin();
  }

  get isAccessValid() {
    if (this.state.isRestrictedAccess) {
      return !!this.props.auth_token || cookies.get('jwtToken')
    }

    return !!this.props.auth_token;
  }

  renderComponent() {
    const { component: Component } = this.props;

    return (props) => {
      if (this.props.auth_validating) {
        return <FullScreenLoading />;
      } else if (this.props.sessionExpired) {
        clearAuthCookies();
        clearSessionId();
        return <SessionExpired signOut={this.signOut} showRestrictedExpirationMessage={this.state.isRestrictedAccess} />;
      } else if (this.isAccessValid) {
        return <Component {...props} />;
      } else {
        return (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: this.props.location }
            }}
          />
        );
      }
    }
  }

  render() {
    const { component, ...rest } = this.props;
    return <Route {...rest} render={this.renderComponent()} />;
  }
}

const mapStateToProps = (state) => {
  return {
    auth_token: state.user.auth_token,
    auth_validating: state.user.auth_validating,
    sessionExpired: state.shared.routes.sessionExpired,
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    signOut: () => dispatch(signOut()),
    redirectToLogin: () => dispatch(push('/login')),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PrivateRoute);



// WEBPACK FOOTER //
// ./src/utils/PrivateRoute.js